import { render, staticRenderFns } from "./copyrightRegistration.vue?vue&type=template&id=038d21e9&scoped=true&"
import script from "./copyrightRegistration.vue?vue&type=script&lang=js&"
export * from "./copyrightRegistration.vue?vue&type=script&lang=js&"
import style0 from "./copyrightRegistration.vue?vue&type=style&index=0&lang=less&"
import style1 from "./copyrightRegistration.vue?vue&type=style&index=1&id=038d21e9&lang=less&scoped=true&"
import style2 from "./copyrightRegistration.vue?vue&type=style&index=2&id=038d21e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038d21e9",
  null
  
)

export default component.exports